import React from 'react';

import { MuralOnboardingAnimation } from './mural-onboarding';
import { AnnouncementAnimationProps } from './types';

/**
 * Bundled native animations available to announcements (mediaType 'animation').
 * The announcement's mediaUrl holds the registry key.
 */
export const ANIMATION_REGISTRY: Record<string, React.ComponentType<AnnouncementAnimationProps>> = {
  'mural-onboarding': MuralOnboardingAnimation,
};
